import { render, staticRenderFns } from "./create-device.vue?vue&type=template&id=282c3e60&"
import script from "./create-device.vue?vue&type=script&lang=ts&"
export * from "./create-device.vue?vue&type=script&lang=ts&"
import style0 from "./create-device.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports